import { createIM, getCommentNotice, sendMessage } from '@api/im';
import { decryptString } from '@utils/common';
import { getFans, getFocus } from '@api/mine';
import { Toast } from 'mand-mobile';

const NIM = require('@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM');

let nim = null;

const state = () => ({
  connected: false,
  gotSession: false,
  gotFriend: false,
  msgs: {},
  nimInfo: {},
  sessions: [],
  followList: [],
  focusList: [],
  delMessage: {},
  commentNotice: [],
  newMessage: {},
  friends: [],
  unreadNewFriend: 0,
  unreadCommentNotice: 0,
  myInfo: {},
  muteList: [],
  blackList: [],
  topSessions: [],
  usersInfo: []
});

const mutations = {
  setNewMessage (state, payload) {
    state.newMessage = payload;
  },
  delMessage (state, payload) {
    const _msg = state.msgs['p2p-' + payload.accid];
    if (_msg) {
      console.log(_msg);
      _msg.splice(_msg.findIndex(item => item.msgid === payload.msgid), 1);

      state.msgs = {
        ...state.msgs,
        [`p2p-${payload.accid}`]: _msg
      };
      state.delMessage = payload;
    }
  },
  setCommentNotice (state, payload) {
    state.commentNotice = payload.new;
    state.unreadCommentNotice = payload.unread_number;
  },
  reset (state) {
    state.connected = false;
    state.msgs = {};
    state.nimInfo = {};
    state.sessions = [];
    state.followList = [];
    state.focusList = [];
    state.friends = [];
    state.showFollowNumber = true;
    state.myInfo = {};
    state.muteList = [];
    state.blackList = [];
    state.topSessions = [];
    state.usersInfo = [];
  },
  setNewFriendUnread (state, payload) {
    state.unreadNewFriend = payload;
  },
  setShowFollowNumber (state, payload) {
    state.showFollowNumber = payload;
  },
  setFollowList (state, payload) {
    state.followList = payload.reverse();
    state.showFollowNumber = true;
  },
  setConnected (state, payload) {
    state.connected = payload;
  },
  updateUserInfo (state, { accid, alias }) {
    const usersInfo = [...state.friends];
    const index = state.friends.findIndex(item => item.account === accid);
    usersInfo[index].alias = alias;

    state.friends = usersInfo;
  },
  removeFollow (state, index) {
    state.followList.splice(index, 1);
  },
  setFocusList (state, data) {
    state.focusList = data;
  },
  removeSession (state, id) {
    state.sessions.splice(state.sessions.findIndex(item => item.id === id), 1);
  },
  setFollowStatus (state, index) {
    state.followList[index].is_each = 1;
  },
  setRelations (state, { blacklist, mutelist }) {
    state.muteList = mutelist;
    // state.muteList = nim.cutRelations(state.muteList, mutelist.invalid);

    state.blackList = nim.mergeRelations(state.blacklist, blacklist);
    state.blackList = nim.cutRelations(state.blackList, blacklist.invalid);
  },
  removeFriend (state, account) {
    state.friends.splice(state.friends.findIndex(item => item.account === account), 1);
  },
  setFriends (state, payload) {
    state.friends = [...payload];
    state.gotFriend = true;
    console.log('>>>>>>>> friends', state.friends);
  },
  setSessions (state, sessions) {
    console.log('------------- sessions', sessions);
    state.sessions = nim.mergeSessions(state.sessions, sessions).sort((a, b) => a.isTop ? -1 : 1);
    state.gotSession = true;
  },
  setTopSessions (state, payload) {
    state.topSessions = payload;
    state.sessions = state.sessions.map(item => ({
      ...item,
      isTop: payload.includes(item.id)
    }));
    localStorage.setItem('topSessions', JSON.stringify(payload));
  },
  setMyInfo (state, payload) {
    state.myInfo = payload;
  },
  setNIMInfo (state, payload) {
    state.nimInfo = payload;
  },
  setUsersInfo (state, payload) {
    state.usersInfo = nim.mergeUsers(state.usersInfo, payload);
  },
  onMessage (state, msgs) {
    console.log('---------------------------- on message', msgs);
    if (!Array.isArray(msgs)) {
      msgs = [msgs];
    }

    msgs.forEach((item) => {
      item.time = typeof item.created_at === 'string' ? new Date(item.created_at.replace(/-/g, '/')).getTime() : Date.now();
    });

    if (msgs.length) {
      const sessionId = msgs[0].sessionId;
      const sorted = nim.mergeMsgs(state.msgs[sessionId], msgs);

      state.msgs = {
        ...state.msgs,
        [sessionId]: sorted
      };
    }
  }
};

const getters = {
  totalUnreadNumber (state) {
    return state.sessions.reduce((c, p) => {
      return c + p.unread;
    }, 0);
  },
  getFriends (state) {
    return state.friends.map(item => {
      const user = (state.usersInfo.find(sub => sub.account === item.account) || {});
      return {
        ...item,
        ...user,
        // 给搜索用户使用
        name: {
          alias: item.alias,
          nick: user.nick
        },
        nick: item.alias || user.nick
      };
    });
  },
  getTargetUserInfo: (state) => (accid) => {
    const friend = state.friends.find(item => item.account === accid);
    const user = state.usersInfo.find(item => item.account === accid);
    if (user) {
      return {
        ...user,
        nick: friend?.alias || user?.nick
      };
    }

    return {};
  },
  getLastMsg: (state) => (accid) => {
    const msg = (state.msgs[`p2p-${accid}`] || []).filter(item => item.type === 'text');
    if (msg) {
      return msg[msg.length - 1];
    } else {
      return {};
    }
  },
  getTargetSessions: (state) => (accid) => {
    return state.sessions.find(item => item.to === accid) || {
      unread: 0,
      to: ''
    };
  }
};

const actions = {
  async getCommentNotice ({ commit }) {
    const { result, data } = await getCommentNotice({ is_list: 0 });
    if (result === 200000) {
      commit('setCommentNotice', data.list);
    }
  },
  resetNim ({ commit }) {
    nim.destroy();
    commit('reset');
  },
  async getFollowList ({ commit }, isPush) {
    const { result, data } = await getFans({ is_notice: '1' });
    if (result === 200000) {
      const list = data.list.filter(item => item.is_each === 0);
      commit('setFollowList', list);
      commit('setNewFriendUnread', data.unread_count);
    }
  },
  getUsersInfo ({ commit, state, rootState }, payload) {
    if (nim && payload.length) {
      nim.getUsers({
        accounts: payload,
        done: (err, data) => {
          if (!err) {
            commit('setUsersInfo', data.map(item => ({
              ...item,
              avatar: rootState.publicStore.publicConfig.avatar_static_url + item.avatar
            })));
          }
        }
      });
    }
  },
  async getFocusList ({ commit }) {
    const { result, data } = await getFocus();
    if (result === 200000) {
      commit('setFocusList', data.list);
    }
  },
  toggleTopSession ({ commit, state }, payload) {
    const topSessions = [
      ...state.topSessions
    ];

    if (topSessions.includes(payload)) {
      topSessions.splice(state.topSessions.findIndex(item => item === payload), 1);
    } else {
      topSessions.push(payload);
    }

    commit('setTopSessions', topSessions);
  },
  initSDK ({ commit, dispatch, state, rootState }, { key, token, accid }) {
    nim = NIM.getInstance({
      db: false,
      debug: false,
      appKey: decryptString(key),
      syncBroadcastMsgs: true,
      account: accid,
      autoMarkRead: false,
      syncSessionUnread: true,
      token: decryptString(token),
      onerror () {
      },
      onupdateuser: function (users) {
        console.log('rootState', rootState);
        commit('setUsersInfo', users);
      },
      onmyinfo: function (info) {
        commit('setMyInfo', {
          ...info,
          avatar: rootState.publicStore.publicConfig.avatar_static_url + info.avatar
        });
      },
      onupdatesessions: function (sessions) {
        commit('setSessions', sessions);
        dispatch('getUsersInfo', sessions.map(item => item.to));
      },
      onsessions: function (sessions) {
        if (localStorage.getItem('topSessions')) {
          try {
            const sessionJSON = JSON.parse(localStorage.getItem('topSessions'));
            if (Array.isArray(sessionJSON)) {
              commit('setSessions', sessions.map(item => ({
                ...item,
                isTop: sessionJSON.includes(item.id)
              })));
              commit('setTopSessions', sessionJSON);
            }
          } catch (e) {

          }
        } else {
          commit('setSessions', sessions);
        }
        dispatch('getUsersInfo', sessions.map(item => item.to));
      },
      onfriends: function (friends) {
        commit('setFriends', friends);
        const accid = friends.map(item => item.account);
        if (accid.length) {
          dispatch('getUsersInfo', accid);
        }
      },
      onmsg: function (data) {
        if (data.type === 'custom') {
          dispatch('getFriends');
        }

        const obj = {
          from_accid: data.from,
          to_accid: data.to,
          created_at: data.time,
          idClient: data.idServer,
          sessionId: data.sessionId
        };

        if (data.type === 'image' || data.type === 'audio') {
          obj.type = data.type === 'image' ? 1 : 2;
          obj.content = JSON.stringify({
            url: data.file.url,
            dur: data.file.dur
          });
        } else if (data.type === 'text') {
          obj.type = 0;
          obj.content = JSON.stringify({
            msg: data.text
          });
        } else {
          obj.type = 100;
          obj.content = data.content;
        }

        commit('onMessage', [obj]);

        let content = {};
        if (data.type === 'custom') {
          try {
            content = JSON.parse(data.content);
          } catch (e) {

          }
        }

        if (((data.type === 'custom' && [1006, 1007, 1008].includes(Number(content.type) || data.type !== 'custom'))) && state.myInfo.account !== data.from &&
          state.muteList.findIndex(item => item.account === data.from) === -1) {
          commit('setNewMessage', {
            type: 'message',
            accid: data.from,
            target: data.from
          });
        }
      },
      // onroamingmsgs: function (data) {
      //   commit('onMessage', data.msgs);
      // },
      oncustomsysmsg: function (data) {
        console.log('oncustomsysmsg', data);
        let json = {};
        try {
          json = JSON.parse(data.content);
        } catch (e) {

        }

        if (json.type === 'delMessage') {
          commit('delMessage', json);
          return;
        }

        dispatch('getFollowList');
        dispatch('getFocusList');
        dispatch('getFriends');
        dispatch('getCommentNotice');

        if (json.type === 'followed') {
          commit('setNewMessage', {
            target: json.nickname,
            accid: json.accid,
            type: 'follow'
          });
        }
      },
      onsysmsg: function (data) {
        dispatch('getFriends');
      },
      onbroadcastmsgs: function (data) {
        console.log('onbroadcastmsgs', data);
      },
      onupdatesysmsg: function (data) {
        console.log('onupdatesysmsg', data);
      },
      onconnect () {
        window.nim = nim;

        dispatch('getFollowList');
        dispatch('getFocusList');
        dispatch('getRelations');
        dispatch('getFriends');
        dispatch('getCommentNotice');
        commit('setConnected', true);
      }
    });
  },
  getRelations ({ commit }) {
    nim.getRelations({
      done: (err, data) => {
        console.log('relations', data);
        if (!err) {
          commit('setRelations', data);
        }
      }
    });
  },
  sendImage ({ commit, state }, { accid, data }) {
    if (state.connected) {
      sendMessage({
        accid,
        type: 1,
        content: JSON.stringify(data)
      });
    }
  },
  sendAudio ({ commit, state }, { accid, data }) {
    if (state.connected) {
      sendMessage({
        accid,
        type: 2,
        content: JSON.stringify(data)
      })
        .then((res) => {
          if (res.result !== 200000) {
            Toast.failed(res.msg);
          }
        });
    }
  },
  sendCustomMsg ({ commit, state }, { msg, accid, type }) {
    if (msg && state.connected) {
      sendMessage({
        accid,
        type,
        content: JSON.stringify(msg)
      })
        .then((res) => {
          if (res.result !== 200000) {
            Toast.failed(res.msg);
          }
        });

      // commit('onMessage', msgObj);
    }
  },
  sendMsg ({ commit, state }, { msg, accid }) {
    if (msg && state.connected) {
      sendMessage({
        accid,
        type: 0,
        content: JSON.stringify({
          msg
        })
      })
        .then((res) => {
          if (res.result !== 200000) {
            Toast.failed(res.msg);
          }
        });
    }
  },
  async getFriends ({ dispatch, commit }) {
    return new Promise(resolve => {
      setTimeout(() => {
        nim.getFriends({
          done: (err, data) => {
            if (!err) {
              commit('setFriends', data);
              const accid = data.map(item => item.account);
              if (accid.length) {
                dispatch('getUsersInfo', accid);
              }
              resolve();
            }
          }
        });
      }, 300);
    });
  },
  deleteSession ({ commit }, accid) {
    nim.deleteLocalSession({
      id: `p2p-${accid}`,
      done: (err, data) => {
        if (!err) {
          commit('removeSession', `p2p-${accid}`);
        }
      }
    });
    nim.deleteSession({
      scene: 'p2p',
      to: accid
    });
  },
  async updateNIMInfo ({ commit, dispatch, state }, payload) {
    if (!state.nimInfo.token) {
      const { result, data } = await createIM();
      if (result === 200000) {
        commit('setNIMInfo', data.list);
        dispatch('initSDK', {
          ...data.list,
          userInfo: payload
        });
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
